module.exports = __webpack_public_path__ + "img/card_4_kzt.e2612acd.svg";